<template>
    <div class="horse-edit-main-studbook flex flex-column mt-2">
        <StudbookEntryStatus v-if="displayStudBookStatus" :horse="horse"/>
        <div class="flex w-full mt-4 gap-5 horse-edit-main-studbook-inner">
            <div v-if="horse.imported || imported" class="studbook studbook-original">
                <div class="header">
                    {{imported ? '*' : null}}
                    {{ $t('message.horseEdit.main.studbook.originalStudbookHeader') }}:
                </div>
                <CustomSelectOneBookType name="previousBookTypeName" v-model="horse.previousBookTypeId" class="w-full"
                                         :placeholder="$t('message.horseEdit.main.studbook.bookTypeNamePlaceholder') + '...'"
                                         :disabled="disableEdit" :rules="imported ? 'required' : null"/>
                <CustomInputText name="previousStudbookRegistryId" :label="$t('message.horseEdit.main.studbook.registryId')"
                                 v-model="horse.previousStudbookRegistryId" class="w-full" noPlaceholder
                                 :disabled="disableEdit"/>
                <div class="flex gap-3 studbook-number-inputs">
                    <CustomInputNumber name="previousBookNumber" :label="$t('message.horseEdit.main.studbook.volume')"
                                       v-model="horse.previousBookNumber" type="number" noPlaceholder
                                       :disabled="disableEdit"/>
                    <CustomInputNumber name="previousBookAppendixNumber" :label="$t('message.horseEdit.main.studbook.supplement')"
                                       v-model="horse.previousBookAppendixNumber" type="number" noPlaceholder
                                       :disabled="disableEdit"/>
                    <CustomInputNumber name="previousBookPage" :label="$t('message.horseEdit.main.studbook.page')"
                                       v-model="horse.previousBookPage" type="number" noPlaceholder
                                       :disabled="disableEdit" />
                </div>
            </div>
            <div class="studbook">
                <div class="header">{{ $t('message.horseEdit.main.studbook.currentStudbookHeader') }}:</div>
                <CustomSelectOneBookType name="bookTypeName" v-model="horse.bookTypeId" class="w-full"
                                         :placeholder="$t('message.horseEdit.main.studbook.bookTypeNamePlaceholder') + '...'"
                                         :select-local="selectLocalStudbook" :disabled="disableEdit || selectLocalStudbook || horse.id"/>
                <CustomInputText name="studbookRegistryId" :label="$t('message.horseEdit.main.studbook.registryId')"
                                 v-model="horse.studbookRegistryId" class="w-full" noPlaceholder :disabled="disableEdit || horse.id"
                                 v-if="!selectLocalStudbook || horse.id"/>
                <div class="flex gap-3 studbook-number-inputs">
                    <CustomInputNumber name="bookNumber" :label="$t('message.horseEdit.main.studbook.volume')"
                                       v-model="horse.bookNumber" type="number" noPlaceholder :disabled="disableEdit"/>
                    <CustomInputNumber name="bookAppendixNumber" :label="$t('message.horseEdit.main.studbook.supplement')"
                                       v-model="horse.bookAppendixNumber" type="number" noPlaceholder :disabled="disableEdit"/>
                    <!--<CustomInputNumber name="bookPage" :label="$t('message.horseEdit.main.studbook.page')"
                                       v-model="horse.bookPage" type="number" />-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneHorseColor from "@/components/form/CustomSelectOneHorseColor.vue";
import CustomSelectOneHorseSex from "@/components/form/CustomSelectOneHorseSex.vue";
import CustomSelectOneBookType from "@/components/form/CustomSelectOneBookType.vue";
import StudbookEntryStatus from "@/views/horse/horseEdit/main/components/StudbookEntryStatus.vue";

export default {
    name: "HorseEditMainStudbooks",
    components: {
        StudbookEntryStatus,
        CustomSelectOneBookType,
        CustomSelectOneHorseSex, CustomSelectOneHorseColor,
        CustomInputText, CustomInputNumber,
        CustomTextButton
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        displayStudBookStatus: {
            type: true,
            default: true,
        },
        disableEdit: {
            type: Boolean,
            default: false,
        },
        selectLocalStudbook: {
            type: Boolean,
            default: false,
        },
        imported: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue"],

    computed: {
        horse: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";
.horse-edit-main-studbook {
    .studbook {
        display: flex;
        flex-direction: column;
        width: 50%;
        gap: 1rem;
        align-items: center;
        background: var(--primary-color);
        padding: 0.8rem 1rem;
        border-radius: 7px;
        font-size: 18px;
        white-space: nowrap;

        .header {
            font-size: 18px;
            display: flex;
            width: 100%;
            justify-content: start;
            text-transform: uppercase;
            font-weight: 600;
            font-family: var(--font-family);
        }

        .name {
            font-size: 24px;
        }

        .custom-select-one .p-dropdown,
        .custom-input-text .p-inputtext,
        .custom-input-number .p-inputtext {
            border-color: var(--text-color);
            color: var(--text-color);
        }

        .custom-select-one .p-disabled {
            background-color: inherit;
        }

        .p-dropdown .p-dropdown-trigger {
            color: var(--text-color);
        }

        .p-dropdown .p-dropdown-label.p-placeholder {
            color: var(--text-color);
        }
    }

    .studbook-original {
        background: var(--primary-color-semitransparent);
    }

    @media screen and (max-width: 1000px) {
        .horse-edit-main-studbook-inner {
            flex-direction: column;
            align-items: center;
            .studbook {
                width: 90%;
            }
        }
    }
}
</style>
